export default __webpack_public_path__ + "static/media/CA-active.745b842a.svg";